export const apiStatus = {
  request: 'REQUEST',
  success: 'SUCCESS',
  failure: 'FAILURE'
}

export const defaultApiReducerState = {
  isRequest: false,
  isSuccess: false,
  isFailure: false,
  data: undefined,
  error: undefined
}

export const apiReducer = (state = defaultApiReducerState, action) => {
  switch (action.type) {
    case apiStatus.request:
      return { ...defaultApiReducerState, isRequest: true }
    case apiStatus.success:
      return { ...defaultApiReducerState, isSuccess: true, data: action.payload }
    case apiStatus.failure:
      return { ...defaultApiReducerState, isFailure: true, error: action.payload }
    default:
      return state
  }
}
